import React from 'react';
import CV from "../../assets/CV_MohammadRifqiFarhansyah.pdf";
import SertifPengkom from '../../assets/SertifikatPengkom.pdf';
import SertifAlgeo from '../../assets/Sertif_Algeo.pdf';
import SertifStima from '../../assets/Sertif_Stima.pdf';
import SertifProbstat from '../../assets/Sertif_Probstat.pdf';
import SentiLab from '../../assets/SentiLab_Copyright.pdf';
import SertifikatACL2025 from "../../assets/SertifikatACL2025.pdf";

export interface NewsItem {
    date: string;
    title: React.ReactNode;
    country: string;
    countryCode: string;
}

export const useNewsData = () => {
    const newsItems: NewsItem[] = [
        {
            date: '2025.08',
            title: "2 of my papers : Ping-Pong (First Author) are accepted to EMNLP-Main Conference and R3 are accepted to TMLR.",
            country: 'Hungaria',
            countryCode: 'HU',
        },
        {
            date: '2025.05',
            title: "Two papers: Javanese Honorifics (First Author) and SEA-VL (Major Contributor)—accepted to ACL 2025 (Main Conference) during my undergrad (covered by Capital One)! See you in Vienna!",
            country: 'Austria',
            countryCode: 'AT',
        },
        {
            date: '2025.04',
            title: "Started my Research Assistantship with Monash University's Data and Democracy Research Group",
            country: 'Australia & Indonesia',
            countryCode: 'AU-ID',
        },
        {
            date: '2025.01',
            title: "Our work, SentiLab-LLM, is officially registered as a copyrighted work by Indonesia's Ministry of Law",
            country: 'Indonesia',
            countryCode: 'ID',
        },
        {
            date: '2024.09',
            title: "My undergraduate thesis will be affiliated with MBZUAI",
            country: 'UAE',
            countryCode: 'AE',
        },
        {
            date: '2023.12',
            title: "Joined Garuda ACE Lab remotely with Boston University!",
            country: 'USA',
            countryCode: 'US',
        },
        {
            date: '2023.08',
            title: "Appointed as a Teaching Assistant for Linear Algebra and Geometry; Algorithm Strategies; and Probability and Statistics at ITB :D",
            country: 'Indonesia',
            countryCode: 'ID',
        },
        {
            date: '2023.04',
            title: "Received travel grant to attend Singapore Amazing Flying Machine Competition (SAFMC)",
            country: 'Singapore',
            countryCode: 'SG',
        },
        {
            date: '2022.08',
            title: "Got my first Teaching Assistant opportunity in USDI, ITB.",
            country: 'Indonesia',
            countryCode: 'ID',
        },
        {
            date: '2021.08',
            title: "Started my Bachelor journey in Institut Teknologi Bandung.",
            country: 'Indonesia',
            countryCode: 'ID',
        },
    ];

    return { newsItems, CV };
};